import ProviderItem from './provider.item.component';
export default ProviderItem;
